import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { format } from 'date-fns';

type IProps = {
  value: string;
  title?: string;
};

export const DateDisplay: React.FC<IProps> = ({ value, title }) => {
  const date = new Date(value);
  const formattedDate = format(date, 'MM-dd-yyyy');

  return (
    <Flex flexDirection={'column'}>
      {title && (
        <Flex flexDirection={'column'}>
          <Flex flexDirection={'row'} gap={2}>
            <Text textStyle="headingItem">{title}</Text>
          </Flex>
        </Flex>
      )}
      <Text textStyle="textBody">{formattedDate}</Text>
    </Flex>
  );
};
